import { render, staticRenderFns } from "./TeachingMaterial.vue?vue&type=template&id=71cc5e0a&scoped=true"
import script from "./TeachingMaterial.vue?vue&type=script&lang=js"
export * from "./TeachingMaterial.vue?vue&type=script&lang=js"
import style0 from "./TeachingMaterial.vue?vue&type=style&index=0&id=71cc5e0a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cc5e0a",
  null
  
)

export default component.exports